import React from 'react';
import ActionButton from '../../action-button';

const NavItem = (props) => (
  <div className="ws-ui-editor-header__nav-item">
    <ActionButton {...props} format="text" size="small" fontWeight="regular" />
  </div>
);

export default NavItem;
